import { useContext } from "react";
import { StoreContext } from "src/contexts/store-context";

export const useStore = () => useContext(StoreContext);
